import haversine from 'haversine-distance';

type TItem = {
  coords: { latitude: string; longitude: string };
};

const getItemDistance = (item: TItem, coords: GeolocationCoordinates) => {
  const calculated = haversine(
    {
      latitude: parseFloat(item.coords.latitude),
      longitude: parseFloat(item.coords.longitude),
    },
    coords,
  );

  return parseFloat((calculated / 1000).toFixed(1));
};

export default function sortItemsByProximity<T extends TItem>(items: T[]) {
  if (!('geolocation' in navigator)) {
    return Promise.resolve({ items, hasPosition: false });
  }

  return new Promise<{ items: T[]; hasPosition: boolean }>(resolve =>
    navigator.geolocation.getCurrentPosition(
      ({ coords }) =>
        resolve({
          items: items.sort((itemA, itemB) => {
            const distanceA = getItemDistance(itemA, coords);
            const distanceB = getItemDistance(itemB, coords);

            if (isNaN(distanceA)) return 1;
            if (isNaN(distanceB)) return -1;

            if (distanceA > distanceB) return 1;
            return -1;
          }),
          hasPosition: true,
        }),
      () => resolve({ items, hasPosition: false }),
    ),
  );
}
